import { z } from 'zod';
import { NotificationChannel } from '../primitives/notification-subject.js';
import { DigestCadence } from '../members/notification-prefs.js';
export const NotificationPreference = z.object({
    kind: z.string().min(1).max(128),
    channel: NotificationChannel,
    enabled: z.boolean(),
    digest: DigestCadence,
});
export const NotificationPreferencePatch = NotificationPreference.extend({
    digest: DigestCadence.optional(),
});
export const NotificationKnownKind = z.object({
    kind: z.string().min(1).max(128),
    schemaVersion: z.literal(1),
});
export const NotificationQuietHours = z.object({
    enabled: z.boolean(),
    start: z.string().regex(/^([01][0-9]|2[0-3]):[0-5][0-9]$/),
    end: z.string().regex(/^([01][0-9]|2[0-3]):[0-5][0-9]$/),
    tzid: z.string().min(1).max(64),
});
export const NotificationQuietHoursPatch = z.object({
    enabled: z.boolean().optional(),
    start: z.string().regex(/^([01][0-9]|2[0-3]):[0-5][0-9]$/).optional(),
    end: z.string().regex(/^([01][0-9]|2[0-3]):[0-5][0-9]$/).optional(),
    tzid: z.string().min(1).max(64).optional(),
});
//# sourceMappingURL=preferences.js.map